module.exports = __webpack_public_path__ + "static/media/calligraphy.d51dbd2e.png";